import draggable from 'vuedraggable'
import _debounce from 'lodash/debounce'
import ContentItemContainer
  from '@components/Widgets/_contentItems/_contentItemContainer.vue'
import uid from '@components/mixins/uid'
import { mapActions, mapGetters } from 'vuex'
import common from '@components/mixins/shared/common'
import feedback from '@components/mixins/shared/feedback'
import inputValidation from '@components/mixins/shared/inputValidation'
import { formatWidgetForApi } from '@utils/formatWidgetApi'
import CloseButton
  from '@components/Widgets/_global/CloseButton/CloseButton.vue'
import WidgetContainer
  from '@components/Widgets/_global/WidgetContainer/WidgetContainer.vue'
import ActionButtons
  from '@components/Widgets/_global/ActionButtons/ActionButtons.vue'
import pxToEm from '@shared/components/mixins/shared/pxToEm'
import { position } from '@shared/meta/widget/options.js'

export default {
  props: {
    widgetObject: {
      required: true,
      type: Object,
    },
    isPreview: {
      required: false,
      type: Boolean,
      default: false,
    },
    isEditor: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    draggable,
    'close-button': CloseButton,
    'widget-container': WidgetContainer,
    'content-item-container': ContentItemContainer,
    'action-buttons': ActionButtons,
  },
  mixins: [uid, feedback, inputValidation, common, pxToEm],
  data() {
    return {
      triggerWidgetAnimation: false,
      positionOptions: position,
    }
  },
  computed: {
    ...mapGetters('campaign/contentItem', ['getDefaultContentItemByTypeName']),
    widget() {
      return formatWidgetForApi(this.widgetObject)
    },
    targetContentItemID() {
      return this.$store.state.campaign.contentItem.targetContentItemID
    },
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
    widgetSide() {
      const rightPositions = [
        this.positionOptions.TOP_RIGHT,
        this.positionOptions.CENTER_RIGHT,
        this.positionOptions.BOTTOM_RIGHT]

      return rightPositions.includes(this.widget.settings.position)
        ? 'right'
        : 'left'
    },
    targetStepIndex() {
      return this.widgetObject.stepsList.indexOf(this.targetStepID)
    },
    contentItemsList: {
      get() {
        return this.widgetObject.steps[this.targetStepID].contentItemsList
      },
      set(value) {
        // Unlink any reactivity
        const newContentItemsList = JSON.parse(JSON.stringify(value))
        let newContentItem = null

        newContentItemsList.forEach((item, index) => {
          if (item !== null && typeof item === 'object') {
            // Make new ID
            const newID = this.getUID()
            newContentItem = newContentItemsList[index]
            newContentItem.id = newID
            // Replace Object with ID (contentItemsList is an array of the ID's)
            newContentItemsList[index] = newID
          }
        })
        // Check if a new ContentItem has appeared in the Array
        if (newContentItem !== null) {
          this.addContentItem(newContentItem)
        }

        this.updateContentItemsList(newContentItemsList)
      },
    },
  },
  watch: {
    widgetObject: {
      handler: _debounce(function (widget) {
        this.saveWidget(widget.id).then(() => {
          console.log('saveWidget success')
        })
      }, 400),
      deep: true,
    },
    'widget.settings.animation'() {
      this.triggerWidgetAnimation = false

      setTimeout(() => {
        this.triggerWidgetAnimation = true
      }, 100)
    },
  },
  created() {
    if (this.isPreview) {
      this.registerEventBusEvents()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.triggerWidgetAnimation = true
    })
  },
  beforeDestroy() {
    this.$eventBus.$off()
  },
  methods: {
    ...mapActions('campaign/widget', ['saveWidget']),
    ...mapActions('campaign/contentItem', [
      'setTargetContentItem',
      'clearTargetContentItem',
      'addContentItem',
      'updateContentItemsList',
    ]),
    ...mapActions('campaign/step', ['setTargetStep']),
    addedContentItem(e) {
      // Remove dropzone indicator
      const contentRestrainers = document.querySelectorAll(
        '.content-item-dropzone')

      contentRestrainers.forEach(contentRestrainer => {
        contentRestrainer.classList.remove('show-dropzone-indicator')
      })
    },
    triggerSetTargetContentItem(id) {
      if (!this.isPreview) {
        this.setTargetContentItem(id)
      }
    },
    triggerCloseWidget() {
      this.$emit('close')
    },
  },
}
